import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { BrowserAuthError } from "@azure/msal-browser";

const Login = (props) => {
  const { instance } = useMsal();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    try {
      // Login using MSAL
      const result = await instance.loginPopup({
        scopes: ["openid", "profile", "email"],
      });

      // Extract email, name, and phone number from MSAL result
      const email = result.account.username;
      const name = result.account.name;
      const phone = result.account.idTokenClaims.phone_number;

      // Set the authenticated account
      props.onAccountChange(result.account);

      // Call back-end API with MSAL information
      const response = await fetch("https://callgeeptapi.azure-api.net/callgeept/createStripeCustomer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          msal: result,
          email: email,
          name: name,
          phone: phone
        }),
      });

      const data = await response.json();

      // Handle response from back-end API
      console.log(data);
      return data; // Return the data from the API call
    } catch (e) {
      if (e instanceof BrowserAuthError && e.errorCode === "user_cancelled") {
        console.log("User cancelled the login flow.");
      } else {
        console.error(e);
      }
    }
  };

  const handleLoginClick = async () => {
    const data = await handleLogin(); // Call the handleLogin function and wait for the data to be returned
    console.log(data); // Log the data to the console
  };

  return (
    <div>
      <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <button onClick={handleLoginClick}>Login</button>
    </div>
  );
};

export default Login;